import {
  faArrowAltCircleLeft,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { useHistory, useParams } from "react-router-dom";
import { Menu, Segment } from "semantic-ui-react";
import Swal from "sweetalert2";
import authService from "../../services/authService";
import { useHttpClient } from "../../util/http-hook";

import NoteIstitutoList from "../components/DettagliNote/NoteIstitutoList";
import InformazioniIstituto from "../components/InformazioniIstituto";

const DettagliIstituto = (props) => {
  const { sendRequest, isLoading } = useHttpClient();
  const [activeItem, setActiveItem] = useState("informazioni");
  const history = useHistory();
  const [infoIstituto, setInfoIstituto] = useState();
  const ref_istituto = useParams().ref_istituto;
  const token = authService.getCurrentToken();

  const handleItemClick = (e, { name }) => {
    setActiveItem(name);
  };

  useEffect(() => {
    const ottieniInfo = async () => {
      try {
        const info = await sendRequest(
          process.env.REACT_APP_BASE_URL +
            `/istituti/infoIstituto/${ref_istituto}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + token,
          }
        );

        setInfoIstituto(info);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Qualcosa è andato storto...",
          text: err.message,
        }).then(() => {
          history.go(0);
          history.push("/");
        });
      }
    };
    ottieniInfo();
  }, [history, ref_istituto, sendRequest, token]);

  const eliminaIstituto = async () => {
    Swal.fire({
      icon: "question",
      title: "Cancellare l'istituto?",
      text:
        "Cancellando l'istituto andranno perse tutte le informazioni riguardanti questo istituto, continuare?",
      confirmButtonText: "Elimina",
      confirmButtonColor: "red",
      cancelButtonText: "Annulla",
      showCancelButton: true,
    }).then(async (value) => {
      if (value.isConfirmed) {
        try {
          await sendRequest(
            process.env.REACT_APP_BASE_URL +
              `/istituti/eliminaIstituto/${ref_istituto}`,
            "DELETE",
            null,
            {
              Authorization: "Bearer " + token,
            }
          );
          Swal.fire({
            icon: "success",
            title: "Istituto eliminato correttamente",
          }).then(() => {
            history.push("/istituti");
          });
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Qualcosa è andato storto...",
            text: error,
          });
        }
      }
    });
  };

  return (
    <React.Fragment>
      <Loader
        type="ThreeDots"
        color="#385898"
        height={80}
        width={80}
        visible={isLoading}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
      {!isLoading && infoIstituto && (
        <div className="card my-2 mx-3">
          <div>
            <div
              className="card-header border-0 flex d-flex justify-content-between"
              style={{
                borderTopRightRadius: "10px",
                borderTopLeftRadius: "10px",
              }}
            >
              <span style={{ fontWeight: 600, fontSize: "120%" }}>
                {infoIstituto.informazioni.denominazione}
              </span>
              {authService.getCurrentRuolo() === "amministratore" && (
                <span
                  role="button"
                  onClick={eliminaIstituto}
                  style={{ fontWeight: 600 }}
                >
                  <FontAwesomeIcon icon={faTrash} /> Elimina
                </span>
              )}
            </div>

            <div className="card-body">
              <div>
                <span
                  role="button"
                  style={{ fontWeight: 600 }}
                  onClick={() => history.goBack()}
                >
                  <FontAwesomeIcon icon={faArrowAltCircleLeft} /> Indietro
                </span>
              </div>
              <Menu tabular stackable>
                <Menu.Item
                  name="informazioni"
                  active={activeItem === "informazioni"}
                  onClick={handleItemClick}
                  color="blue"
                />
                <Menu.Item
                  name="note"
                  active={activeItem === "note"}
                  onClick={handleItemClick}
                  color="blue"
                />
              </Menu>
              <Segment attached="bottom">
                <div className="row"></div>
                {activeItem === "informazioni" && (
                  <InformazioniIstituto info={infoIstituto.informazioni} />
                )}
                {activeItem === "note" && (
                  <NoteIstitutoList
                    note={infoIstituto.note}
                    ref_istituto={infoIstituto.informazioni.id_istituto}
                  />
                )}
              </Segment>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default DettagliIstituto;
